module.exports = __webpack_public_path__ + "static/media/HCMM073.5a2e60d0.jpg";